module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/group/create"
    }
  }, [_c('el-button', {
    staticClass: "m-2",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("添加群")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "img",
      "label": "图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          style: ({
            width: '80px',
            height: 'auto',
            margin: '10px 0 0 0'
          }),
          attrs: {
            "src": _vm._f("ossurl")(scope.row.img),
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "俱乐部名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 1) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("上线")]) : _vm._e(), _vm._v(" "), (scope.row.status === 3) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("下线")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": '/group/' + scope.row.id
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v("编辑")])], 1)]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56e4b184","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/group/group-list.vue
// module id = 798
// module chunks = 1